export default [{
    nameFr: 'Afghanistan',
    nameEn: 'Afghanistan',
    code: 'AF'
  },
  {
    nameFr: 'Afrique du Sud',
    nameEn: 'South Africa',
    code: 'ZA'
  },
  {
    nameFr: 'Albanie',
    nameEn: 'Albania',
    code: 'AL'
  },
  {
    nameFr: 'Algérie',
    nameEn: 'Algeria',
    code: 'DZ'
  },
  {
    nameFr: 'Allemagne',
    nameEn: 'Germany',
    code: 'DE'
  },
  {
    nameFr: 'Andorre',
    nameEn: 'Andorra',
    code: 'AD'
  },
  {
    nameFr: 'Angola',
    nameEn: 'Angola',
    code: 'AO'
  },
  {
    nameFr: 'Anguilla',
    nameEn: 'Anguilla',
    code: 'AI'
  },
  {
    nameFr: 'Antarctique',
    nameEn: 'Antarctica',
    code: 'AQ'
  },
  {
    nameFr: 'Antigua-et-Barbuda',
    nameEn: 'Antigua and Barbuda',
    code: 'AG'
  },
  {
    nameFr: 'Antilles néerlandaises',
    nameEn: 'Antilles néerlandaises',
    code: 'AN'
  },
  {
    nameFr: 'Arabie saoudite',
    nameEn: 'Saudi Arabia',
    code: 'SA'
  },
  {
    nameFr: 'Argentine',
    nameEn: 'Argentina',
    code: 'AR'
  },
  {
    nameFr: 'Arménie',
    nameEn: 'Armenia',
    code: 'AM'
  },
  {
    nameFr: 'Aruba',
    nameEn: 'Aruba',
    code: 'AW'
  },
  {
    nameFr: 'Australie',
    nameEn: 'Australia',
    code: 'AU'
  },
  {
    nameFr: 'Autriche',
    nameEn: 'Austria',
    code: 'AT'
  },
  {
    nameFr: 'Azerbaïdjan',
    nameEn: 'Azerbaijan',
    code: 'AZ'
  },
  {
    nameFr: 'Bahamas',
    nameEn: 'Bahamas',
    code: 'BS'
  },
  {
    nameFr: 'Bahreïn',
    nameEn: 'Bahrain',
    code: 'BH'
  },
  {
    nameFr: 'Bangladesh',
    nameEn: 'Bangladesh',
    code: 'BD'
  },
  {
    nameFr: 'Barbade',
    nameEn: 'Barbados',
    code: 'BB'
  },
  {
    nameFr: 'Biélorussie',
    nameEn: 'Belarus',
    code: 'BY'
  },
  {
    nameFr: 'Belgique',
    nameEn: 'Belgium',
    code: 'BE'
  },
  {
    nameFr: 'Belize',
    nameEn: 'Belize',
    code: 'BZ'
  },
  {
    nameFr: 'Bénin',
    nameEn: 'Benin',
    code: 'BJ'
  },
  {
    nameFr: 'Bermudes',
    nameEn: 'Bermuda',
    code: 'BM'
  },
  {
    nameFr: 'Bhoutan',
    nameEn: 'Bhutan',
    code: 'BT'
  },
  {
    nameFr: 'Bolivie',
    nameEn: 'Bolivia',
    code: 'BO'
  },
  {
    nameFr: 'Bosnie-Herzégovine',
    nameEn: 'Bosnia and Herzegovina',
    code: 'BA'
  },
  {
    nameFr: 'Botswana',
    nameEn: 'Botswana',
    code: 'BW'
  },
  {
    nameFr: 'Brésil',
    nameEn: 'Brazil',
    code: 'BR'
  },
  {
    nameFr: 'Brunéi Darussalam',
    nameEn: 'Brunei',
    code: 'BN'
  },
  {
    nameFr: 'Bulgarie',
    nameEn: 'Bulgaria',
    code: 'BG'
  },
  {
    nameFr: 'Burkina Faso',
    nameEn: 'Burkina Faso',
    code: 'BF'
  },
  {
    nameFr: 'Burundi',
    nameEn: 'Burundi',
    code: 'BI'
  },
  {
    nameFr: 'Cambodge',
    nameEn: 'Cambodia',
    code: 'KH'
  },
  {
    nameFr: 'Cameroun',
    nameEn: 'Cameroon',
    code: 'CM'
  },
  {
    nameFr: 'Canada',
    nameEn: 'Canada',
    code: 'CA'
  },
  {
    nameFr: 'Cap-Vert',
    nameEn: 'Cape Verde',
    code: 'CV'
  },
  {
    nameFr: 'Ceuta et Melilla',
    nameEn: 'Ceuta et Melilla',
    code: 'EA'
  },
  {
    nameFr: 'Chili',
    nameEn: 'Chile',
    code: 'CL'
  },
  {
    nameFr: 'Chine',
    nameEn: 'China',
    code: 'CN'
  },
  {
    nameFr: 'Chypre',
    nameEn: 'Cyprus',
    code: 'CY'
  },
  {
    nameFr: 'Colombie',
    nameEn: 'Colombia',
    code: 'CO'
  },
  {
    nameFr: 'Comores',
    nameEn: 'Comoros',
    code: 'KM'
  },
  {
    nameFr: 'Congo-Brazzaville',
    nameEn: 'Republic of the Congo',
    code: 'CG'
  },
  {
    nameFr: 'Corée du Nord',
    nameEn: 'North Korea',
    code: 'KP'
  },
  {
    nameFr: 'République de Corée',
    nameEn: 'South Korea',
    code: 'KR'
  },
  {
    nameFr: 'Costa Rica',
    nameEn: 'Costa Rica',
    code: 'CR'
  },
  {
    nameFr: 'Côte d’Ivoire',
    nameEn: 'Ivory Coast',
    code: 'CI'
  },
  {
    nameFr: 'Croatie',
    nameEn: 'Croatia',
    code: 'HR'
  },
  {
    nameFr: 'Cuba',
    nameEn: 'Cuba',
    code: 'CU'
  },
  {
    nameFr: 'Danemark',
    nameEn: 'Denmark',
    code: 'DK'
  },
  {
    nameFr: 'Diego Garcia',
    nameEn: 'Diego Garcia',
    code: 'DG'
  },
  {
    nameFr: 'Djibouti',
    nameEn: 'Djibouti',
    code: 'DJ'
  },
  {
    nameFr: 'Dominique',
    nameEn: 'Dominica',
    code: 'DM'
  },
  {
    nameFr: 'Égypte',
    nameEn: 'Egypt',
    code: 'EG'
  },
  {
    nameFr: 'El Salvador',
    nameEn: 'El Salvador',
    code: 'SV'
  },
  {
    nameFr: 'Émirats arabes unis',
    nameEn: 'United Arab Emirates',
    code: 'AE'
  },
  {
    nameFr: 'Équateur',
    nameEn: 'Ecuador',
    code: 'EC'
  },
  {
    nameFr: 'Érythrée',
    nameEn: 'Eritrea',
    code: 'ER'
  },
  {
    nameFr: 'Espagne',
    nameEn: 'Spain',
    code: 'ES'
  },
  {
    nameFr: 'Estonie',
    nameEn: 'Estonia',
    code: 'EE'
  },
  {
    nameFr: 'État de la Cité du Vatican',
    nameEn: 'Vatican',
    code: 'VA'
  },
  {
    nameFr: 'États fédérés de Micronésie',
    nameEn: 'Micronesia',
    code: 'FM'
  },
  {
    nameFr: 'États-Unis',
    nameEn: 'United States',
    code: 'US'
  },
  {
    nameFr: 'Éthiopie',
    nameEn: 'Ethiopia',
    code: 'ET'
  },
  {
    nameFr: 'Fidji',
    nameEn: 'Fiji',
    code: 'FJ'
  },
  {
    nameFr: 'Finlande',
    nameEn: 'Finland',
    code: 'FI'
  },
  {
    nameFr: 'France',
    nameEn: 'France',
    code: 'FR'
  },
  {
    nameFr: 'Gabon',
    nameEn: 'Gabon',
    code: 'GA'
  },
  {
    nameFr: 'Gambie',
    nameEn: 'Gambia',
    code: 'GM'
  },
  {
    nameFr: 'Géorgie',
    nameEn: 'Georgia',
    code: 'GE'
  },
  {
    nameFr: 'Géorgie du Sud et les îles Sandwich du Sud',
    nameEn: 'South Georgia and the South Sandwich Islands',
    code: 'GS'
  },
  {
    nameFr: 'Ghana',
    nameEn: 'Ghana',
    code: 'GH'
  },
  {
    nameFr: 'Gibraltar',
    nameEn: 'Gibraltar',
    code: 'GI'
  },
  {
    nameFr: 'Grèce',
    nameEn: 'Greece',
    code: 'GR'
  },
  {
    nameFr: 'Grenade',
    nameEn: 'Grenada',
    code: 'GD'
  },
  {
    nameFr: 'Groenland',
    nameEn: 'Greenland',
    code: 'GL'
  },
  /*{
    nameFr: 'Guadeloupe',
    nameEn: 'Guadeloupe',
    code: 'GP'
  },*/
  {
    nameFr: 'Guam',
    nameEn: 'Guam',
    code: 'GU'
  },
  {
    nameFr: 'Guatemala',
    nameEn: 'Guatemala',
    code: 'GT'
  },
  {
    nameFr: 'Guernesey',
    nameEn: 'Guernsey',
    code: 'GG'
  },
  {
    nameFr: 'Guinée',
    nameEn: 'Guinea',
    code: 'GN'
  },
  {
    nameFr: 'Guinée équatoriale',
    nameEn: 'Equatorial Guinea',
    code: 'GQ'
  },
  {
    nameFr: 'Guinée-Bissau',
    nameEn: 'Guinea-Bissau',
    code: 'GW'
  },
  {
    nameFr: 'Guyana',
    nameEn: 'Guyana',
    code: 'GY'
  },
  /*{
    nameFr: 'Guyane française',
    nameEn: 'French Guiana',
    code: 'GF'
  },*/
  {
    nameFr: 'Haïti',
    nameEn: 'Haiti',
    code: 'HT'
  },
  {
    nameFr: 'Honduras',
    nameEn: 'Honduras',
    code: 'HN'
  },
  {
    nameFr: 'Hongrie',
    nameEn: 'Hungary',
    code: 'HU'
  },
  {
    nameFr: 'Île Bouvet',
    nameEn: 'Bouvet Island',
    code: 'BV'
  },
  {
    nameFr: 'Île Christmas',
    nameEn: 'Christmas Island',
    code: 'CX'
  },
  /*{
    nameFr: 'Île Clipperton',
    nameEn: 'Île Clipperton',
    code: 'CP'
  },*/
  {
    nameFr: 'Île de l\'Ascension',
    nameEn: 'Île de l\'Ascension',
    code: 'AC'
  },
  {
    nameFr: 'Île de Man',
    nameEn: 'Isle of Man',
    code: 'IM'
  },
  {
    nameFr: 'Île Norfolk',
    nameEn: 'Norfolk Island',
    code: 'NF'
  },
  {
    nameFr: 'Îles Åland',
    nameEn: 'Aland Islands',
    code: 'AX'
  },
  {
    nameFr: 'Îles Caïmans',
    nameEn: 'Cayman Islands',
    code: 'KY'
  },
  {
    nameFr: 'Îles Canaries',
    nameEn: 'Îles Canaries',
    code: 'IC'
  },
  {
    nameFr: 'Îles Cocos - Keeling',
    nameEn: 'Cocos Islands',
    code: 'CC'
  },
  {
    nameFr: 'Îles Cook',
    nameEn: 'Cook Islands',
    code: 'CK'
  },
  {
    nameFr: 'Îles Féroé',
    nameEn: 'Faroe Islands',
    code: 'FO'
  },
  {
    nameFr: 'Îles Heard et MacDonald',
    nameEn: 'Heard Island and McDonald Islands',
    code: 'HM'
  },
  {
    nameFr: 'Îles Malouines',
    nameEn: 'Falkland Islands',
    code: 'FK'
  },
  {
    nameFr: 'Îles Mariannes du Nord',
    nameEn: 'Northern Mariana Islands',
    code: 'MP'
  },
  {
    nameFr: 'Îles Marshall',
    nameEn: 'Marshall Islands',
    code: 'MH'
  },
  {
    nameFr: 'Îles Mineures Éloignées des États-Unis',
    nameEn: 'United States Minor Outlying Islands',
    code: 'UM'
  },
  {
    nameFr: 'Îles Salomon',
    nameEn: 'Solomon Islands',
    code: 'SB'
  },
  {
    nameFr: 'Îles Turks et Caïques',
    nameEn: 'Turks and Caicos Islands',
    code: 'TC'
  },
  {
    nameFr: 'Îles Vierges britanniques',
    nameEn: 'British Virgin Islands',
    code: 'VG'
  },
  {
    nameFr: 'Îles Vierges des États-Unis',
    nameEn: 'U.S. Virgin Islands',
    code: 'VI'
  },
  {
    nameFr: 'Inde',
    nameEn: 'India',
    code: 'IN'
  },
  {
    nameFr: 'Indonésie',
    nameEn: 'Indonesia',
    code: 'ID'
  },
  {
    nameFr: 'Irak',
    nameEn: 'Iraq',
    code: 'IQ'
  },
  {
    nameFr: 'Iran',
    nameEn: 'Iran',
    code: 'IR'
  },
  {
    nameFr: 'Irlande',
    nameEn: 'Ireland',
    code: 'IE'
  },
  {
    nameFr: 'Islande',
    nameEn: 'Iceland',
    code: 'IS'
  },
  {
    nameFr: 'Israël',
    nameEn: 'Israel',
    code: 'IL'
  },
  {
    nameFr: 'Italie',
    nameEn: 'Italy',
    code: 'IT'
  },
  {
    nameFr: 'Jamaïque',
    nameEn: 'Jamaica',
    code: 'JM'
  },
  {
    nameFr: 'Japon',
    nameEn: 'Japan',
    code: 'JP'
  },
  {
    nameFr: 'Jersey',
    nameEn: 'Jersey',
    code: 'JE'
  },
  {
    nameFr: 'Jordanie',
    nameEn: 'Jordan',
    code: 'JO'
  },
  {
    nameFr: 'Kazakhstan',
    nameEn: 'Kazakhstan',
    code: 'KZ'
  },
  {
    nameFr: 'Kenya',
    nameEn: 'Kenya',
    code: 'KE'
  },
  {
    nameFr: 'Kirghizistan',
    nameEn: 'Kyrgyzstan',
    code: 'KG'
  },
  {
    nameFr: 'Kiribati',
    nameEn: 'Kiribati',
    code: 'KI'
  },
  {
    nameFr: 'Koweït',
    nameEn: 'Kuwait',
    code: 'KW'
  },
  {
    nameFr: 'Laos',
    nameEn: 'Laos',
    code: 'LA'
  },
  {
    nameFr: 'Lesotho',
    nameEn: 'Lesotho',
    code: 'LS'
  },
  {
    nameFr: 'Lettonie',
    nameEn: 'Latvia',
    code: 'LV'
  },
  {
    nameFr: 'Liban',
    nameEn: 'Lebanon',
    code: 'LB'
  },
  {
    nameFr: 'Libéria',
    nameEn: 'Liberia',
    code: 'LR'
  },
  {
    nameFr: 'Libye',
    nameEn: 'Libya',
    code: 'LY'
  },
  {
    nameFr: 'Liechtenstein',
    nameEn: 'Liechtenstein',
    code: 'LI'
  },
  {
    nameFr: 'Lituanie',
    nameEn: 'Lithuania',
    code: 'LT'
  },
  {
    nameFr: 'Luxembourg',
    nameEn: 'Luxembourg',
    code: 'LU'
  },
  {
    nameFr: 'Macédoine',
    nameEn: 'Macedonia',
    code: 'MK'
  },
  {
    nameFr: 'Madagascar',
    nameEn: 'Madagascar',
    code: 'MG'
  },
  {
    nameFr: 'Malaisie',
    nameEn: 'Malaysia',
    code: 'MY'
  },
  {
    nameFr: 'Malawi',
    nameEn: 'Malawi',
    code: 'MW'
  },
  {
    nameFr: 'Maldives',
    nameEn: 'Maldives',
    code: 'MV'
  },
  {
    nameFr: 'Mali',
    nameEn: 'Mali',
    code: 'ML'
  },
  {
    nameFr: 'Malte',
    nameEn: 'Malta',
    code: 'MT'
  },
  {
    nameFr: 'Maroc',
    nameEn: 'Morocco',
    code: 'MA'
  },
  /*{
    nameFr: 'Martinique',
    nameEn: 'Martinique',
    code: 'MQ'
  },*/
  {
    nameFr: 'Maurice',
    nameEn: 'Mauritius',
    code: 'MU'
  },
  {
    nameFr: 'Mauritanie',
    nameEn: 'Mauritania',
    code: 'MR'
  },
  /*{
    nameFr: 'Mayotte',
    nameEn: 'Mayotte',
    code: 'YT'
  },*/
  {
    nameFr: 'Mexique',
    nameEn: 'Mexico',
    code: 'MX'
  },
  {
    nameFr: 'Moldavie',
    nameEn: 'Moldova',
    code: 'MD'
  },
  {
    nameFr: 'Monaco',
    nameEn: 'Monaco',
    code: 'MC'
  },
  {
    nameFr: 'Mongolie',
    nameEn: 'Mongolia',
    code: 'MN'
  },
  {
    nameFr: 'Monténégro',
    nameEn: 'Montenegro',
    code: 'ME'
  },
  {
    nameFr: 'Montserrat',
    nameEn: 'Montserrat',
    code: 'MS'
  },
  {
    nameFr: 'Mozambique',
    nameEn: 'Mozambique',
    code: 'MZ'
  },
  {
    nameFr: 'Myanmar',
    nameEn: 'Myanmar',
    code: 'MM'
  },
  {
    nameFr: 'Namibie',
    nameEn: 'Namibia',
    code: 'NA'
  },
  {
    nameFr: 'Nauru',
    nameEn: 'Nauru',
    code: 'NR'
  },
  {
    nameFr: 'Népal',
    nameEn: 'Nepal',
    code: 'NP'
  },
  {
    nameFr: 'Nicaragua',
    nameEn: 'Nicaragua',
    code: 'NI'
  },
  {
    nameFr: 'Niger',
    nameEn: 'Niger',
    code: 'NE'
  },
  {
    nameFr: 'Nigéria',
    nameEn: 'Nigeria',
    code: 'NG'
  },
  {
    nameFr: 'Niue',
    nameEn: 'Niue',
    code: 'NU'
  },
  {
    nameFr: 'Norvège',
    nameEn: 'Norway',
    code: 'NO'
  },
  /*{
    nameFr: 'Nouvelle-Calédonie',
    nameEn: 'New Caledonia',
    code: 'NC'
  },*/
  {
    nameFr: 'Nouvelle-Zélande',
    nameEn: 'New Zealand',
    code: 'NZ'
  },
  {
    nameFr: 'Oman',
    nameEn: 'Oman',
    code: 'OM'
  },
  {
    nameFr: 'Ouganda',
    nameEn: 'Uganda',
    code: 'UG'
  },
  {
    nameFr: 'Ouzbékistan',
    nameEn: 'Uzbekistan',
    code: 'UZ'
  },
  {
    nameFr: 'Pakistan',
    nameEn: 'Pakistan',
    code: 'PK'
  },
  {
    nameFr: 'Palaos',
    nameEn: 'Palau',
    code: 'PW'
  },
  {
    nameFr: 'Panama',
    nameEn: 'Panama',
    code: 'PA'
  },
  {
    nameFr: 'Papouasie-Nouvelle-Guinée',
    nameEn: 'Papua New Guinea',
    code: 'PG'
  },
  {
    nameFr: 'Paraguay',
    nameEn: 'Paraguay',
    code: 'PY'
  },
  {
    nameFr: 'Pays-Bas',
    nameEn: 'Netherlands',
    code: 'NL'
  },
  {
    nameFr: 'Pérou',
    nameEn: 'Peru',
    code: 'PE'
  },
  {
    nameFr: 'Philippines',
    nameEn: 'Philippines',
    code: 'PH'
  },
  {
    nameFr: 'Pitcairn',
    nameEn: 'Pitcairn',
    code: 'PN'
  },
  {
    nameFr: 'Pologne',
    nameEn: 'Poland',
    code: 'PL'
  },
  /*{
    nameFr: 'Polynésie française',
    nameEn: 'French Polynesia',
    code: 'PF'
  },*/
  {
    nameFr: 'Porto Rico',
    nameEn: 'Puerto Rico',
    code: 'PR'
  },
  {
    nameFr: 'Portugal',
    nameEn: 'Portugal',
    code: 'PT'
  },
  {
    nameFr: 'Qatar',
    nameEn: 'Qatar',
    code: 'QA'
  },
  {
    nameFr: 'R.A.S. chinoise de Hong Kong',
    nameEn: 'Hong Kong',
    code: 'HK'
  },
  {
    nameFr: 'R.A.S. chinoise de Macao',
    nameEn: 'Macao',
    code: 'MO'
  },
  {
    nameFr: 'régions éloignées de l’Océanie',
    nameEn: 'régions éloignées de l’Océanie',
    code: 'QO'
  },
  {
    nameFr: 'République centrafricaine',
    nameEn: 'Central African Republic',
    code: 'CF'
  },
  {
    nameFr: 'République démocratique du Congo',
    nameEn: 'Democratic Republic of the Congo',
    code: 'CD'
  },
  {
    nameFr: 'République dominicaine',
    nameEn: 'Dominican Republic',
    code: 'DO'
  },
  {
    nameFr: 'République Tchèque',
    nameEn: 'Czech Republic',
    code: 'CZ'
  },
  /*{
    nameFr: 'Réunion',
    nameEn: 'Reunion',
    code: 'RE'
  },*/
  {
    nameFr: 'Roumanie',
    nameEn: 'Romania',
    code: 'RO'
  },
  {
    nameFr: 'Royaume-Uni',
    nameEn: 'United Kingdom',
    code: 'GB'
  },
  {
    nameFr: 'Russie',
    nameEn: 'Russia',
    code: 'RU'
  },
  {
    nameFr: 'Rwanda',
    nameEn: 'Rwanda',
    code: 'RW'
  },
  {
    nameFr: 'Sahara occidental',
    nameEn: 'Western Sahara',
    code: 'EH'
  },
  /*{
    nameFr: 'Saint-Barthélémy',
    nameEn: 'Saint Barthelemy',
    code: 'BL'
  },*/
  {
    nameFr: 'Saint-Kitts-et-Nevis',
    nameEn: 'Saint Kitts and Nevis',
    code: 'KN'
  },
  {
    nameFr: 'Saint-Marin',
    nameEn: 'San Marino',
    code: 'SM'
  },
  /*{
    nameFr: 'Saint-Martin',
    nameEn: 'Saint Martin',
    code: 'MF'
  },*/
  /*{
    nameFr: 'Saint-Pierre-et-Miquelon',
    nameEn: 'Saint Pierre and Miquelon',
    code: 'PM'
  },*/
  {
    nameFr: 'Saint-Vincent-et-les Grenadines',
    nameEn: 'Saint Vincent and the Grenadines',
    code: 'VC'
  },
  {
    nameFr: 'Sainte-Hélène',
    nameEn: 'Saint Helena',
    code: 'SH'
  },
  {
    nameFr: 'Sainte-Lucie',
    nameEn: 'Saint Lucia',
    code: 'LC'
  },
  {
    nameFr: 'Samoa',
    nameEn: 'Samoa',
    code: 'WS'
  },
  {
    nameFr: 'Samoa américaines',
    nameEn: 'American Samoa',
    code: 'AS'
  },
  {
    nameFr: 'Sao Tomé-et-Principe',
    nameEn: 'Sao Tome and Principe',
    code: 'ST'
  },
  {
    nameFr: 'Sénégal',
    nameEn: 'Senegal',
    code: 'SN'
  },
  {
    nameFr: 'Serbie',
    nameEn: 'Serbia',
    code: 'RS'
  },
  {
    nameFr: 'Serbie-et-Monténégro',
    nameEn: 'Serbie-et-Monténégro',
    code: 'CS'
  },
  {
    nameFr: 'Seychelles',
    nameEn: 'Seychelles',
    code: 'SC'
  },
  {
    nameFr: 'Sierra Leone',
    nameEn: 'Sierra Leone',
    code: 'SL'
  },
  {
    nameFr: 'Singapour',
    nameEn: 'Singapore',
    code: 'SG'
  },
  {
    nameFr: 'Slovaquie',
    nameEn: 'Slovakia',
    code: 'SK'
  },
  {
    nameFr: 'Slovénie',
    nameEn: 'Slovenia',
    code: 'SI'
  },
  {
    nameFr: 'Somalie',
    nameEn: 'Somalia',
    code: 'SO'
  },
  {
    nameFr: 'Soudan',
    nameEn: 'Sudan',
    code: 'SD'
  },
  {
    nameFr: 'Sri Lanka',
    nameEn: 'Sri Lanka',
    code: 'LK'
  },
  {
    nameFr: 'Suède',
    nameEn: 'Sweden',
    code: 'SE'
  },
  {
    nameFr: 'Suisse',
    nameEn: 'Switzerland',
    code: 'CH'
  },
  {
    nameFr: 'Suriname',
    nameEn: 'Suriname',
    code: 'SR'
  },
  {
    nameFr: 'Svalbard et Île Jan Mayen',
    nameEn: 'Svalbard and Jan Mayen',
    code: 'SJ'
  },
  {
    nameFr: 'Swaziland',
    nameEn: 'Swaziland',
    code: 'SZ'
  },
  {
    nameFr: 'Syrie',
    nameEn: 'Syria',
    code: 'SY'
  },
  {
    nameFr: 'Tadjikistan',
    nameEn: 'Tajikistan',
    code: 'TJ'
  },
  {
    nameFr: 'Taïwan',
    nameEn: 'Taiwan',
    code: 'TW'
  },
  {
    nameFr: 'Tanzanie',
    nameEn: 'Tanzania',
    code: 'TZ'
  },
  {
    nameFr: 'Tchad',
    nameEn: 'Chad',
    code: 'TD'
  },
  /*{
    nameFr: 'Terres australes françaises',
    nameEn: 'French Southern Territories',
    code: 'TF'
  },*/
  {
    nameFr: 'Territoire britannique de l\'océan Indien',
    nameEn: 'British Indian Ocean Territory',
    code: 'IO'
  },
  {
    nameFr: 'Territoire palestinien',
    nameEn: 'Palestinian Territory',
    code: 'PS'
  },
  {
    nameFr: 'Thaïlande',
    nameEn: 'Thailand',
    code: 'TH'
  },
  {
    nameFr: 'Timor oriental',
    nameEn: 'East Timor',
    code: 'TL'
  },
  {
    nameFr: 'Togo',
    nameEn: 'Togo',
    code: 'TG'
  },
  {
    nameFr: 'Tokelau',
    nameEn: 'Tokelau',
    code: 'TK'
  },
  {
    nameFr: 'Tonga',
    nameEn: 'Tonga',
    code: 'TO'
  },
  {
    nameFr: 'Trinité-et-Tobago',
    nameEn: 'Trinidad and Tobago',
    code: 'TT'
  },
  {
    nameFr: 'Tristan da Cunha',
    nameEn: 'Tristan da Cunha',
    code: 'TA'
  },
  {
    nameFr: 'Tunisie',
    nameEn: 'Tunisia',
    code: 'TN'
  },
  {
    nameFr: 'Turkménistan',
    nameEn: 'Turkmenistan',
    code: 'TM'
  },
  {
    nameFr: 'Turquie',
    nameEn: 'Turkey',
    code: 'TR'
  },
  {
    nameFr: 'Tuvalu',
    nameEn: 'Tuvalu',
    code: 'TV'
  },
  {
    nameFr: 'Ukraine',
    nameEn: 'Ukraine',
    code: 'UA'
  },
  /*{
    nameFr: 'Union européenne',
    nameEn: 'Union européenne',
    code: 'EU'
  },*/
  {
    nameFr: 'Uruguay',
    nameEn: 'Uruguay',
    code: 'UY'
  },
  {
    nameFr: 'Vanuatu',
    nameEn: 'Vanuatu',
    code: 'VU'
  },
  {
    nameFr: 'Venezuela',
    nameEn: 'Venezuela',
    code: 'VE'
  },
  {
    nameFr: 'Viêt Nam',
    nameEn: 'Vietnam',
    code: 'VN'
  },
  /*{
    nameFr: 'Wallis-et-Futuna',
    nameEn: 'Wallis and Futuna',
    code: 'WF'
  },*/
  {
    nameFr: 'Yémen',
    nameEn: 'Yemen',
    code: 'YE'
  },
  {
    nameFr: 'Zambie',
    nameEn: 'Zambia',
    code: 'ZM'
  },
  {
    nameFr: 'Zimbabwe',
    nameEn: 'Zimbabwe',
    code: 'ZW'
  }
];



// WEBPACK FOOTER //
// ./client/app/permission/countries.js